var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" Chart ")]),_c('connections-graph')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }